import { EcomItem } from '../services/EcomService'

export function thumbnail(item: EcomItem) {
    let largeImageUrl
    for (const mediaItem of item.media) {
        if (
            mediaItem.media_type === 'image' &&
            mediaItem.media_name === 'large' &&
            mediaItem.url
        ) {
            largeImageUrl = mediaItem.url
            break
        }
    }
    return largeImageUrl
}
